import submitCommand from '../../../services/submitCommand';
export const switchOrg = (userId: string, orgId: string) =>
  submitCommand(userId, { id: userId, accountId: orgId }, 'SelectAccount', 'AccountSelected');
